module.exports = __webpack_public_path__ + "static/media/chat.e51c8c81.svg";